import { get } from "../index";

export const getActivityLog = (data) => {
  let query = "";
  for (let d in { ...data })
    query +=
      data[d] || (data[d] == 0 && data[d] !== "")
        ? d + "=" + data[d] + "&"
        : "";
  return get(`/activity-logs?` + query);
};
